/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	inprogress: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '& path': {
      fill: '#000'
    },
    '& .button': {
      color: '#F88923 !important',
      background: '#FDE6D2',
      border: '1px solid #F88923',
      '& path': {
        fill: 'none'
      },
      pointerEvents: 'none'
    }
  }
}; 